import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, requireAdmin = false }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-bone" data-testid="auth-loading">
                <div className="font-serif text-2xl text-espresso">Loading…</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }
    if (requireAdmin && user.role !== "admin" && user.role !== "employee") {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
}
